import { render, staticRenderFns } from "./start_4im.vue?vue&type=template&id=e297e126&scoped=true&"
import script from "./start_4im.vue?vue&type=script&lang=js&"
export * from "./start_4im.vue?vue&type=script&lang=js&"
import style0 from "./start_4im.vue?vue&type=style&index=0&id=e297e126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e297e126",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
